import React from 'react'
import { RecoilRoot } from 'recoil'
import BoletimMedicao from './index'

const BoletimMedicaoRecoil = () => {
    return (
        <RecoilRoot>
            <BoletimMedicao />
        </RecoilRoot>
    )
}

export default BoletimMedicaoRecoil